export const DEFAULT_COLUMN_COLOR = '#155DFC';
export const FALLBACK_COLUMN_COLOR = '#6A7282';
export const FALLBACK_COLUMN_BG_COLOR = '#F3F4F6';
export const BOARD_COLUMN_WIDTH_CLASS_NAME =
    'min-w-72 max-w-[350px] flex-[1_1_313px]';
export const BOARD_COLUMN_HOVER_WIDTH_CLASS_NAME = 'hover:w-[313px]';
